const leftPositionModifier = 535;
const topPositionModifier = 192;
const width = '635px';
const height = '280px';

export const opinionLabDimensions = {
  getLeft: (width: number) => (width - leftPositionModifier) / 2,
  getTop: (height: number) => (height - topPositionModifier) / 2,
  width,
  height
};
